import React from 'react';
import { Row, Button, Col, Spinner } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Form from 'react-bootstrap/Form';
import MaterialTable from 'material-table';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withAuthorization } from '../Session';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import './styles.css';
import queryString from 'query-string';
import ReactExport from 'react-export-excel';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'COMPLETE', value: 'COMPLETE' },
    { key: 'PENDING', value: 'PENDING' },
    { key: 'CANCELED', value: 'CANCELED' },
    
]
const searchBy = [
    { key: 'Amount', value: 'amount' },
    { key: 'Gift Card Brand ', value: 'productName' },
    { key: 'MasterGC Account ', value: 'MasterGiftCard' },
    { key: 'Order ID', value: 'orderId' },
    { key: 'Created On', value: 'Date' },
    { key: 'Status', value: 'status' }
];


export function MaterialUIPickers(props) {
    if (props.id == 'date-picker-inline1') {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = date.setDate(date.getDate() - 30);
        //var firstDay = new Date(y, m, 1);
    } else {
        //var firstDay = new Date();
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        //var firstDay = date.setDate(date.getDate() -15);
    }
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="none"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    maxDate={new Date()}
                    autoOk={true}
                    KeyboardButtonProps={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

class GCStatement extends React.Component {
    _isMounted = false;

    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        isLastPage:false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'amount',
        loading: false,
        fromDate: '',
        toDate: this.getFormattedDateTo(new Date()),

        alert: 0,
        alertMessage: '',
        storeTag: '',
        backArrow: false,
        flag: 0,
        data: [],
        reportData:[],
        AllMasterGiftCards:[],
        ShowFlashMessage: false,
        FlashMessage: '',
    };

    dataArray = [];

    getFormattedDate(date) {
        // date.setDate(date.getDate() -30);
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    getFormattedDateTo(date) {
        //date.setDate(date.getDate() -15);
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.relaodData();
        this.getAllMasterGiftCards()
            
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async getAllMasterGiftCards() {
        let bodyData = {
            userRole: 'Admins',
            search_key: '',
            search_by: '',
            moveTo: false,
            StartAt: [],
            LastDocument: false,
            FirstDocument: false,
            perPage: 100
        };
        await RestServices.getAllMasterGiftCards(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    let MasterGiftCardsArray =[];
                    let MasterGiftCardsList = responseData.list;
                    for (let i = 0; i < MasterGiftCardsList.length; i++) {
                        MasterGiftCardsArray.push({ key: MasterGiftCardsList[i].title, value: MasterGiftCardsList[i].title })
                    }
                    if (this._isMounted) {
                        this.setState({
                            AllMasterGiftCards: MasterGiftCardsArray
                        });
                    }
                    
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async relaodData() {
        if (this._isMounted) {
            this.setState({
                loading: true,
                DownloadReady:false,
            });
        }

        let bodyData = {
            search_key: this.state.search_key?this.state.search_key:this.state.fromDate,
            fromDate:this.state.fromDate,
            toDate:this.state.toDate,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
            ProfileUniqeID:this.props.UniqeID
        };
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/getMyGiftCards'
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            loading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                if(responseData.list.length>0){
                   
                    
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            isLastPage: responseData.list.length <parseInt(this.state.perPage) ? true:false,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                            data: responseData.list,
                            alert: 0,
                            loading: false
                        });
                    }
                    
                    }else{
                    if (this._isMounted) {
                        this.setState({
                            data:[],
                            isLastPage: true,
                            alert: 0,
                            loading: false
                        });
                    }
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        data: [],
                        loading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            search_by: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0,
            fromDate:''
        });
        setTimeout(() => {
            this.relaodData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ moveTo: 'Next' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ moveTo: 'Prev' });
            setTimeout(() => {
                this.relaodData();
            }, 500);
        }
    };

    onChangeValues = (event) => {
        this.setState({ search_key: '' }); 
        if (event.target.value === '')
            this.setState({ [event.target.name]: '' });
        else {
            this.setState({ [event.target.name]: event.target.value });
        }
    };

    getLinkAmount(itemAmount) {
        if (itemAmount > 0) {
            return '₹' + parseFloat(itemAmount).toFixed(2);
        } else {
            itemAmount = 0;
            return '₹' + parseFloat(itemAmount).toFixed(2);
        }
    }
    

    createReport = async () => {
        if (this._isMounted) {
            this.setState({
                loading: true,
                DownloadReady:false,
            });
        }
        let bodyData = {
            search_key: this.state.search_key?this.state.search_key:this.state.fromDate,
            fromDate:this.state.fromDate,
            toDate:this.state.toDate,
            search_by: this.state.search_by,
            moveTo: false,
            StartAt: [],
            LastDocument: false,
            FirstDocument: false,
            perPage: 10000000,
            ProfileUniqeID:this.props.UniqeID
        };
        await RestServices.getMyGiftCards(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (this._isMounted) {
                    this.setState({
                        reportData: responseData.list,
                        alert: 0,
                        loading: false,
                        DownloadReady:true,
                    });
                }

            })
                
        
            }

    render() {
        var giftcards = [];
        var AmazonReportData =[]
        var dataList = this.state.data;
        var reportData = this.state.reportData;
        for (let i = 0; i < dataList.length; i++) {
           giftcards.push(
                <tr key={dataList[i].orderId}>
                    <td>{getFormattedDateTime(dataList[i].Date)}</td>
                    <td>{dataList[i].productName}</td>
                    <td>{dataList[i].MasterGiftCard}</td>
                    <td>{this.getLinkAmount(parseFloat(dataList[i].amount)*dataList[i].qty)}</td>
                    <td>{this.getLinkAmount(dataList[i].discount)}%</td>
                    <td>{this.getLinkAmount(dataList[i].discountAmount)}</td>
                    
                    <td>{dataList[i].status}</td>
                </tr>
            );
            
        }

        for (let i = 0; i < reportData.length; i++) {
            if(reportData[i].status ==='COMPLETE'){

                var allCards = reportData[i].cards
                for (let c = 0; c < allCards.length; c++) {
                AmazonReportData.push({
                    refno:reportData[i].refno?reportData[i].refno:'null',
                    giftOrderId:reportData[i].orderId?reportData[i].orderId:'null',
                    sku:reportData[i].GCSku?reportData[i].GCSku:'null',
                    productName:reportData[i].productName,
                    ProfileUniqeID:reportData[i].ProfileUniqeID?reportData[i].ProfileUniqeID:'null',
                    cardId:allCards[c].cardId,
                    cardNumber:allCards[c].cardNumber,
                    cardPin:allCards[c].cardPin,
                    issuanceDate:allCards[c].issuanceDate,
                    validity:allCards[c].validity,
                    amount:allCards[c].amount?parseFloat(allCards[c].amount):0,
                    Comments:reportData[i].Description?reportData[i].Description:'null',
                });
              }

                
            }
        }

        return (
            <div>
                {this.state.ShowFlashMessage && (
                    <Alert className="FlashMessage" variant="success">
                        {this.state.FlashMessage}
                    </Alert>
                )}

                {this.state.loading && <Spinner animation="border" />}

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                <Row style={{ justifyContent: 'right' }}>
                            <Col
                                style={{
                                    justifyContent: 'right',
                                    textAlign: 'right'
                                }}
                            >
                                <Form.Group
                                    as={Row}
                                    style={{
                                        justifyContent: 'right',
                                        marginRight: '0'
                                    }}
                                >
                                    <select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="search_by"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_by}
                                    >
                                        {searchBy.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                Search By {search.key}
                                            </option>
                                        ))}
                                    </select>
                                    {this.state.search_by =='status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by =='MasterGiftCard' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {this.state.AllMasterGiftCards.map((MasterGC) => (
                                            <option
                                                key={MasterGC.key}
                                                value={MasterGC.value}
                                            >
                                                {MasterGC.key}
                                            </option>
                                        ))}
                                    </select>}

                                    {this.state.search_by !=='MasterGiftCard' && this.state.search_by !=='status' && this.state.search_by =='Date' &&<Row style={{ marginLeft: '0px',marginRight: '0px' }}>
                                    <Col>
                                        <MaterialUIPickers
                                id="date-picker-inline1"
                                label="From Date"
                                setDate={(date) => {
                                    this.setState({
                                        search_key: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Col>
                            <Col>
                                    <MaterialUIPickers
                                id="date-picker-inline2"
                                label="To Date"
                                setDate={(date) => {
                                    this.setState({
                                        toDate: this.getFormattedDate(date)
                                    });
                                }}
                            />
                            </Col>
                                    </Row>}
                                    {this.state.search_by !=='MasterGiftCard' && this.state.search_by !=='status' && this.state.search_by !=='Date' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                    <Button
                                        variant="primary"
                                        onClick={this.submitSearch}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        style={{ marginLeft: '1rem' }}
                                        variant="primary"
                                        onClick={this.restSearch}
                                    >
                                        Reset
                                    </Button>
                                    {!this.state.DownloadReady ?<Button style={{ marginLeft: '1rem' }} variant="primary" onClick={this.createReport}>
                                    Generate Report
                                </Button>:<ExcelFile
                            element={ <Button style={{ marginLeft: '1rem' }} variant="primary">Download Report </Button>}
                            filename="Amazon Report"
                                >
                            <ExcelSheet data={AmazonReportData} name="Amazon Report" >
                            <ExcelColumn
                                    label="Order Date"
                                    value="issuanceDate"
                                />
                                <ExcelColumn
                                    label="Order ID"
                                    value="giftOrderId"
                                />
                                <ExcelColumn
                                    label="SKU"
                                    value="sku"
                                />
                                <ExcelColumn
                                    label="GC Name"
                                    value="productName"
                                />
                                <ExcelColumn
                                    label="GC Reference Number"
                                    value="refno"
                                />
                                <ExcelColumn
                                    label="Store ID"
                                    value="ProfileUniqeID"
                                />
                                
                                <ExcelColumn
                                    label="Amount"
                                    value="amount"
                                />
                                <ExcelColumn
                                    label="CardId"
                                    value="cardId"
                                />
                                <ExcelColumn
                                    label="CardNumber"
                                    value="cardNumber"
                                />
                                <ExcelColumn
                                    label="CardPin"
                                    value="cardPin"
                                />
                                <ExcelColumn
                                    label="Validity"
                                    value="validity"
                                />

                                <ExcelColumn
                                    label="Comments"
                                    value="Comments"
                                />
                                
                                
                            </ExcelSheet>
                        </ExcelFile>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <table className="table">
                            <thead>
                                <tr className="tableHead">
                                    <td>Issuance Date</td>
                                    <td>GC Name</td>
                                    <td>MasterGC Account</td>
                                    <td>Amount</td>
                                    <td>Discount</td>
                                    <td>Discount Amount</td>
                                    <td>Status</td>
                                </tr>
                            </thead>
                            <tbody>{giftcards}</tbody>
                        </table>

                        <div>
                            <hr />
                        </div>
                        <Row className="custom_pagination">
                            {this.state.StartAt.length > 1 && (
                                <Col>
                                    <Button
                                        onClick={this.paginatePrev}
                                        variant="primary"
                                    >
                                        Prev
                                    </Button>
                                </Col>
                            )}
                            {this.state.StartAt.length < 2 && (
                                <Col>
                                    <Button variant="secondary" disabled={true}>
                                        Prev
                                    </Button>
                                </Col>
                            )}

                            <Col style={{ textAlign: 'center' }}>
                                {'Items per page:'}
                                <select
                                    className="items_per_page"
                                    onChange={this.handlePageSizeChange}
                                    value={this.state.perPage}
                                >
                                    {pageSizes.map((size) => (
                                        <option key={size} value={size}>
                                            {size}
                                        </option>
                                    ))}
                                </select>
                                Page: {this.state.StartAt.length}
                            </Col>

                            <Col style={{ textAlign: 'right' }}>
                                {this.state.isLastPage && (
                                    <Button variant="secondary" disabled={true}>
                                        Next
                                    </Button>
                                )}

                                {!this.state.isLastPage && (
                                    <Button
                                        onClick={this.paginateNext}
                                        variant="primary"
                                    >
                                        Next
                                    </Button>
                                )}
                            </Col>
                        </Row>
                
                
            </div>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(GCStatement);
